"use client";

import { useState, useEffect } from "react";
import { FiFilter, FiChevronDown, FiChevronUp } from "react-icons/fi";
import AuthenticatedLayout from "./../../Layouts/AuthenticatedLayout";
import InfoSection from "../../Components/InfoSection";
import GroupedContainer from "./../../Components/GroupedContainer";
import HorizontalTabs from "../../Components/HorizontalTabs";
import LoadContainer from "./LoadContainer";
import { fetchTransportData } from "./../../lib/api";

// Import the modal components
import AddPhotosModal from "./AddPhotosModal";
import ConfirmationModal from "./ConfirmationModal";
import SendDocumentModal from "./SendDocumentModal";
import ReleaseModal from "./ReleaseModal";
import PdfGatePassModal from "./PdfGatePassModal";
import PdfSelectionModal from "./PdfSelectionModal";
import OptionsModal from "./OptionsModal";
import GatePassModal from "./GatePassModal";
import OthersModal from "./OthersModal";
import TransportDetailsModal from "./TransportDetailsModal";
import axios from "axios";

function Loads() {
  const [activeTab, setActiveTab] = useState(0);
  const [items, setItems] = useState([]);
  const [meta, setMeta] = useState({
    current_page: 1,
    last_page: 1,
    per_page: 10,
    total: 0,
  });
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);

  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [sortBy, setSortBy] = useState("dispatch_date");
  const [sortDirection, setSortDirection] = useState("desc");
  const [orderId, setOrderId] = useState("");
  const [isFiltersOpen, setIsFiltersOpen] = useState(false);

  // Add state variables for modals
  const [selectedLoad, setSelectedLoad] = useState(null);
  const [isAddPhotosModalOpen, setIsAddPhotosModalOpen] = useState(false);
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [isSendDocumentModalOpen, setIsSendDocumentModalOpen] = useState(false);
  const [isReleaseModalOpen, setIsReleaseModalOpen] = useState(false);
  const [isPdfGatePassModalOpen, setIsPdfGatePassModalOpen] = useState(false);
  const [isPdfSelectionModalOpen, setIsPdfSelectionModalOpen] = useState(false);
  const [isOptionsModalOpen, setIsOptionsModalOpen] = useState(false);
  const [isGatePassModalOpen, setIsGatePassModalOpen] = useState(false);
  const [isOthersModalOpen, setIsOthersModalOpen] = useState(false);
  const [isTransportDetailsModalOpen, setIsTransportDetailsModalOpen] =
    useState(false);
  const [selectedLoadItemId, setSelectedLoadItemId] = useState(null);
  const [loadToDelete, setLoadToDelete] = useState(null);
  const [selectedLoadTransportId, setSelectedLoadTransportId] = useState(null);
  const [drivers, setDrivers] = useState([]);
  const [shippers, setShippers] = useState([]);

  const tabs = [
    { name: "New" },
    { name: "Assigned" },
    { name: "Confirmed" },
    { name: "Picked Up" },
    { name: "Dropped Off" },
    { name: "Delivered" },
    { name: "Billed" },
    { name: "Paid" },
    { name: "Cancelled" },
  ];

  const tabToStatusId = (tabIndex) => {
    switch (tabIndex) {
      case 0:
        return 1; // New
      case 1:
        return 2; // Assigned
      case 2:
        return 3; // Confirmed
      case 3:
        return 4; // Picked Up
      case 4:
        return 5; // Dropped Off
      case 5:
        return 6; // Delivered
      case 6:
        return 7; // Billed
      case 7:
        return 8; // Paid
      case 8:
        return 9; // Cancelled
      default:
        return 1; // Default agora é New (status 1)
    }
  };

  useEffect(() => {
    const fetchDrivers = async () => {
      try {
        const userToken = localStorage.getItem("token");
        const response = await axios.get(`https://new.cajuu.app/api/driver`, {
          headers: {
            "Screen-Name": "/NewLoad",
            Authorization: `Bearer ${userToken}`,
          },
        });
        setDrivers(response.data.data);
      } catch (error) {
        console.error("Erro ao buscar drivers", error);
      }
    };

    const fetchShippers = async () => {
      try {
        const userToken = localStorage.getItem("token");
        const response = await axios.get(`https://new.cajuu.app/api/shipper`, {
          headers: {
            "Screen-Name": "/NewLoad",
            Authorization: `Bearer ${userToken}`,
          },
        });
        setShippers(response.data.data);
      } catch (error) {
        console.error("Erro ao buscar shippers", error);
      }
    };

    const getTransports = async () => {
      try {
        setLoading(true);
        const statusId = tabToStatusId(activeTab);
        const { items, meta } = await fetchTransportData({
          page,
          per_page: perPage,
          sort_by: sortBy,
          sort_direction: sortDirection,
          ...(statusId ? { status: statusId } : {}),
          ...(orderId ? { order_id: orderId } : {}),
        });
        setItems(items);
        setMeta(meta);
      } catch (error) {
        console.error("Error fetching transport data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchDrivers();
    fetchShippers();
    getTransports();
  }, [activeTab, page, perPage, sortBy, sortDirection, orderId]);

  const refreshData = async () => {
    try {
      setRefreshing(true);
      const statusId = tabToStatusId(activeTab);
      const { items, meta } = await fetchTransportData({
        page,
        per_page: perPage,
        sort_by: sortBy,
        sort_direction: sortDirection,
        ...(statusId ? { status: statusId } : {}),
        ...(orderId ? { order_id: orderId } : {}),
      });
      setItems(items);
      setMeta(meta);
    } catch (error) {
      console.error("Error refreshing transport data:", error);
    } finally {
      setRefreshing(false);
    }
  };

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
    setPage(1);
  };

  const openConfirmationModal = (loadId) => {
    setLoadToDelete(loadId);
    setIsConfirmationModalOpen(true);
  };

  const closeConfirmationModal = () => {
    setLoadToDelete(null);
    setIsConfirmationModalOpen(false);
  };

  const handleConfirmDelete = async () => {
    if (loadToDelete) {
      await handleDeleteLoad(loadToDelete);
      console.log("Load deleted:", loadToDelete);
      closeConfirmationModal();
    }
  };

  const handleDeleteLoad = async (id) => {
    try {
      const updated = items.filter((load) => load.id !== id);
      setItems(updated);
    } catch (error) {
      console.error("Error deleting load:", error);
    }
  };

  const openPdfSelectionModal = (load, loadItemId) => {
    setSelectedLoad(load);
    setSelectedLoadItemId(loadItemId);
    setIsPdfSelectionModalOpen(true);
  };

  const closePdfSelectionModal = () => {
    setIsPdfSelectionModalOpen(false);
  };

  const handlePdfSelection = (pdfType) => {
    setIsPdfSelectionModalOpen(false);
    if (pdfType === "gatepass") {
      setIsGatePassModalOpen(true);
    } else if (pdfType === "others") {
      setIsOthersModalOpen(true);
    } else if (pdfType === "release") {
      setIsReleaseModalOpen(true);
    }
  };

  const openAddPhotosModal = (load) => {
    setSelectedLoad(load);
    setIsAddPhotosModalOpen(true);
  };

  const closeAddPhotosModal = () => {
    setIsAddPhotosModalOpen(false);
  };

  const openSendDocumentModal = (load) => {
    setSelectedLoad(load);
    setIsSendDocumentModalOpen(true);
  };

  const closeSendDocumentModal = () => {
    setIsSendDocumentModalOpen(false);
  };

  const handleSendDocument = async ({ documentType, customerEmail } = {}) => {
    console.log("Sending document:", documentType, "to", customerEmail);
    closeSendDocumentModal();
  };

  const openGatePassModal = (load, loadItemId) => {
    setSelectedLoad(load);
    setSelectedLoadItemId(loadItemId);
    setIsGatePassModalOpen(true);
  };

  const closeGatePassModal = () => {
    setIsGatePassModalOpen(false);
  };

  const handleOpenPdfGatePassModal = (loadTransportId) => {
    setSelectedLoadTransportId(loadTransportId);
    setIsPdfGatePassModalOpen(true);
  };

  const handleClosePdfGatePassModal = () => {
    setIsPdfGatePassModalOpen(false);
    setSelectedLoadTransportId(null);
  };

  const openTransportDetailsModal = (load) => {
    setSelectedLoad(load);
    setIsTransportDetailsModalOpen(true);
  };

  const prepareLoadData = (data) => {
    return data.map((load) => ({
      ...load,
      user: load.user
        ? typeof load.user === "object"
          ? load.user.name || "Unknown User"
          : load.user
        : "Unknown User",
      driver: load.driver
        ? typeof load.driver === "object"
          ? load.driver.name || "Unknown Driver"
          : load.driver
        : "Unknown Driver",
      shipper: load.shipper
        ? typeof load.shipper === "object"
          ? load.shipper.name || "Unknown Shipper"
          : load.shipper
        : "Unknown Shipper",
    }));
  };

  return (
    <AuthenticatedLayout>
      <div className="text-white text-xl sm:text-2xl px-4 sm:px-4">
        <GroupedContainer>
          <InfoSection title="LOADS" description="All Loads" />

          <div className="mt-4">
            <div className="flex items-center justify-end">
              <button
                type="button"
                onClick={() => setIsFiltersOpen((prev) => !prev)}
                aria-expanded={isFiltersOpen}
                aria-label="Toggle filters"
                className="inline-flex items-center gap-2 rounded-xl border border-zinc-700 bg-zinc-900/90 px-3 py-2 text-sm text-white transition hover:border-orange-500 hover:bg-zinc-800"
              >
                <FiFilter className="text-base" />
                <span className="hidden sm:inline">Filters</span>
                {isFiltersOpen ? (
                  <FiChevronUp className="text-base" />
                ) : (
                  <FiChevronDown className="text-base" />
                )}
              </button>
            </div>

            <div
              className={`overflow-hidden transition-all duration-300 ease-in-out ${
                isFiltersOpen
                  ? "max-h-[32rem] opacity-100 mt-3"
                  : "max-h-0 opacity-0 mt-0"
              }`}
            >
              <div className="rounded-2xl border border-zinc-800 bg-zinc-950/60 p-3">
                <div className="flex flex-col gap-3 lg:flex-row lg:items-center">
                  <input
                    className="w-full bg-zinc-900 border border-zinc-700 rounded-xl px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-orange-500 lg:flex-1"
                    placeholder="Search by Order ID"
                    value={orderId}
                    onChange={(e) => {
                      setOrderId(e.target.value);
                      setPage(1);
                    }}
                  />

                  <select
                    className="w-full bg-zinc-900 border border-zinc-700 rounded-xl px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-orange-500 lg:w-[140px] lg:min-w-[140px]"
                    value={perPage}
                    onChange={(e) => {
                      setPerPage(Number(e.target.value));
                      setPage(1);
                    }}
                  >
                    <option value={10}>10 / page</option>
                    <option value={20}>20 / page</option>
                    <option value={30}>30 / page</option>
                    <option value={50}>50 / page</option>
                  </select>

                  <select
                    className="w-full bg-zinc-900 border border-zinc-700 rounded-xl px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-orange-500 lg:w-[220px] lg:min-w-[220px]"
                    value={sortBy}
                    onChange={(e) => {
                      setSortBy(e.target.value);
                      setPage(1);
                    }}
                  >
                    <option value="dispatch_date">Dispatch Date</option>
                    <option value="pickup_date">Pickup Date</option>
                    <option value="expected_pickup_date">Expected Pickup</option>
                    <option value="dropoff_date">Dropoff Date</option>
                    <option value="expected_dropoff_date">Expected Dropoff</option>
                    <option value="payment_rate">Payment Rate</option>
                  </select>

                  <select
                    className="w-full bg-zinc-900 border border-zinc-700 rounded-xl px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-orange-500 lg:w-[140px] lg:min-w-[140px]"
                    value={sortDirection}
                    onChange={(e) => {
                      setSortDirection(e.target.value);
                      setPage(1);
                    }}
                  >
                    <option value="desc">Desc</option>
                    <option value="asc">Asc</option>
                  </select>

                  {/*
                  <button
                    className="w-full bg-orange-500 hover:bg-orange-600 text-white rounded-xl px-4 py-2 text-sm lg:w-auto"
                    onClick={refreshData}
                    disabled={loading || refreshing}
                  >
                    Refresh
                  </button>
                  */}
                </div>
              </div>
            </div>
          </div>

          <HorizontalTabs
            tabs={tabs}
            activeTab={activeTab}
            onTabChange={handleTabChange}
          />
        </GroupedContainer>

        <div className="mt-4 sm:mt-6">
          {loading ? (
            <div className="flex justify-center items-center h-40">
              <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-orange-500"></div>
            </div>
          ) : (
            <>
              <LoadContainer
                data={prepareLoadData(items)}
                meta={meta}
                activeStatus={tabs[activeTab].name}
                onPrev={() => setPage((p) => Math.max(1, p - 1))}
                onNext={() =>
                  setPage((p) => Math.min(meta?.last_page ?? 1, p + 1))
                }
                onRefresh={refreshData}
                isLoading={loading}
                onOpenAddPhotos={openAddPhotosModal}
                onOpenSendDocument={openSendDocumentModal}
                onOpenPdfSelection={openPdfSelectionModal}
                onOpenTransportDetails={openTransportDetailsModal}
                onOpenConfirmation={openConfirmationModal}
                onOpenOptions={handleOpenPdfGatePassModal}
                onOpenGatePass={openGatePassModal}
                drivers={drivers}
                shippers={shippers}
              />
            </>
          )}
        </div>
      </div>

      <AddPhotosModal
        isOpen={isAddPhotosModalOpen}
        onClose={closeAddPhotosModal}
        idTransport={selectedLoad?.id}
        loadItems={selectedLoad?.load_items || []}
      />

      <SendDocumentModal
        isOpen={isSendDocumentModalOpen}
        onClose={closeSendDocumentModal}
        onSend={handleSendDocument}
        transportId={selectedLoad?.id}
        vehicles={selectedLoad?.load_items || []}
      />

      <ConfirmationModal
        isOpen={isConfirmationModalOpen}
        onRequestClose={closeConfirmationModal}
        onConfirm={handleConfirmDelete}
        message="Are you sure you want to delete this load?"
      />

      <PdfSelectionModal
        isOpen={isPdfSelectionModalOpen}
        onClose={closePdfSelectionModal}
        onSelect={handlePdfSelection}
      />

      <GatePassModal
        isOpen={isGatePassModalOpen}
        onClose={closeGatePassModal}
        idLoadTransport={selectedLoad?.id}
        loadItems={selectedLoad?.load_items || []}
        selectedLoadItemId={selectedLoadItemId}
      />

      <ReleaseModal
        isOpen={isReleaseModalOpen}
        onClose={() => setIsReleaseModalOpen(false)}
        idLoadTransport={selectedLoad?.id}
        loadItems={selectedLoad?.load_items || []}
        selectedLoadItemId={selectedLoadItemId}
      />

      <OthersModal
        isOpen={isOthersModalOpen}
        onClose={() => setIsOthersModalOpen(false)}
        idLoadTransport={selectedLoad?.id}
        loadItems={selectedLoad?.load_items || []}
        selectedLoadItemId={selectedLoadItemId}
      />

      <OptionsModal
        isOpen={isOptionsModalOpen}
        onClose={() => setIsOptionsModalOpen(false)}
        transport={selectedLoad}
        onOpenPdfGatePassModal={handleOpenPdfGatePassModal}
      />

      <PdfGatePassModal
        isOpen={isPdfGatePassModalOpen}
        onClose={handleClosePdfGatePassModal}
        loadTransportId={selectedLoadTransportId}
      />

      <TransportDetailsModal
        isOpen={isTransportDetailsModalOpen}
        onClose={() => setIsTransportDetailsModalOpen(false)}
        transport={selectedLoad}
        userToken={localStorage.getItem("userToken")}
      />
    </AuthenticatedLayout>
  );
}

export default Loads;